import React from 'react';
import { DivX } from '@dui';
import { ButtonGroup, classNames, Div } from '@vkontakte/vkui';
import { DeviceType } from '../../types';
import styles from './ContestFinishingSection.module.css';

interface ContestFinishingSectionProps {
  titleComponent: React.ReactNode;
  subtitle: React.ReactNode;
  buttonGroupContent: React.ReactNode;
  mode: 'vertical' | 'horizontal';
  deviceType?: DeviceType;
}

/**
 * Лейаут для блоков, которые рисуются после завершения фазы голосования
 */
export function ContestFinishingSection(props: ContestFinishingSectionProps) {
  const { titleComponent, subtitle, mode, buttonGroupContent, deviceType } = props;

  return (
    <div className={classNames(styles.root, deviceType && styles[`root__${deviceType}`])}>
      {titleComponent}

      <DivX>{subtitle}</DivX>
      <Div className={styles.buttonsContainer}>
        <ButtonGroup className={styles.buttonGroup} stretched mode={mode} align="center">
          {buttonGroupContent}
        </ButtonGroup>
      </Div>
    </div>
  );
}
